import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION5: PdfComponent = {
  type: 'section',
  id: 's1s5',
  title: '5. Obligations of the Parties as Data Controllers',
  content: [
    {
      type: 'altText',
      id: 's1s5heading',
      content: [
        'Each party shall, taking into account the state of technological development, implement and maintain appropriate technical and organisational security measures to ensure a level of security appropriate to the risk. These shall include, at a minimum, measures to:',
      ],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 's1s5bullets',
      bulletType: 'alpha',
      content: [
        {
          copy: 'prevent unauthorised persons from gaining access to systems used to process Personal Information;',
        },
        {
          copy: 'prevent unauthorised use of such systems;',
        },
        {
          copy: 'ensure that persons entitled to use data processing systems have access only to Personal Information to which they have a right of access, and that Personal Information cannot be read, copied, modified or deleted without proper authorisation during processing, use or storage;',
        },
        {
          copy: 'ensure that Personal Information cannot be read, copied, modified or deleted without proper authorisation during electronic transmission or transport; and',
        },
        {
          copy: 'ensure auditability of system inputs and modifications, such that it is possible to establish who entered, modified, or deleted Personal Information and when.',
        },
      ],
    },
  ],
};
